/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
// You can delete this file if you're not using it
import React from "react";

import AppDataContextProvider from "../design-system/shared/contexts/app-data/AppDataContextProvider";
import { MediaContextProvider } from "../design-system/shared/contexts/media/MediaContext";
import UiStateContextProvider from "../design-system/shared/contexts/ui-state/UiStateContextProvider";

require("css.escape");

// Runs once per client session
const bootstrapVendorConsent = () => {
  const CONSENT_COOKIE = "c_c";

  // Guard against attaching twice
  if (window.__cCConsentBootstrapped) {
    return;
  }

  const getCookie = (name) => {
    const prefix = `${name}=`;
    const match = document.cookie.split("; ").find((c) => c.indexOf(prefix) === 0);
    return match ? match.substring(prefix.length) : undefined;
  };

  // Already consented on a previous visit — nothing to do.
  if (getCookie(CONSENT_COOKIE) === "true") {
    return;
  }

  // Scope to the Gatsby root so CMP banner clicks dont trigger
  const gatsbyRoot = document.getElementById("___gatsby");
  if (!gatsbyRoot) {
    console.warn("consent bootstrap skipped: #___gatsby not found");
    return;
  }

  const READY_DEADLINE = Date.now() + 15000;

  const handleFirstClick = () => {
    if (!window.ours_consent) {
      // Prevent the event listener from being attached indefinitely if the CMP never loads.
      // If cmp script hasnt loaded (or is feature toggled off) after 15 seconds the next click releases the event listener for session
      if (Date.now() > READY_DEADLINE) {
        gatsbyRoot.removeEventListener("click", handleFirstClick, true);
      }
      return;
    }

    try {
      window.ours_consent.acceptAll();
      window.ours_consent.hide();
    } catch (err) {
      console.error("ours_consent bootstrap failed", err);
      return;
    }

    const oneYear = 60 * 60 * 24 * 365;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${CONSENT_COOKIE}=true; path=/; max-age=${oneYear}; SameSite=Lax${secure}`;

    gatsbyRoot.removeEventListener("click", handleFirstClick, true);
  };

  gatsbyRoot.addEventListener("click", handleFirstClick, true);
  window.__cCConsentBootstrapped = true;
};

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`);
  }

  bootstrapVendorConsent();
};

export const wrapRootElement = ({ element }) => (
  <UiStateContextProvider>
    <AppDataContextProvider>
      <MediaContextProvider>{element}</MediaContextProvider>
    </AppDataContextProvider>
  </UiStateContextProvider>
);
